import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {IQuestionElementProps} from '../../../../incase-domain/elements/base/questionElementBase';
import QuestionLayout from '../common/QuestionLayout';
import QuestionAnswer, {AnswerTypes} from '../question/QuestionAnswer';
import {IElementQuestionYesNoV2} from '../../../../incase-domain/elements/question/questionYesNoV2';
import {usePresentationLabels} from '../../../../hooks/usePresentationLabels';
import {getAnswerStyles} from '../common/getStyles';

function presEditYesNoAnswerKey(text: string): 'presEditPage.yes' | 'presEditPage.no' {
    const lower = text.toLowerCase();
    return lower === 'no' ? 'presEditPage.no' : 'presEditPage.yes';
}

function answerLabelCode(text: string): 'elements-yesnoquestion-yes' | 'elements-yesnoquestion-no' {
    return text.toLowerCase() === 'no' ? 'elements-yesnoquestion-no' : 'elements-yesnoquestion-yes';
}

const mapAnswerType = (type: string): AnswerTypes => {
    switch (type) {
        case 'correct':
            return AnswerTypes.CORRECT;
        case 'incorrect':
            return AnswerTypes.INCORRECT;
        case 'debatable':
            return AnswerTypes.DEBATABLE;
        default:
            return AnswerTypes.NONE;
    }
};

function YesNoQuestionElementV2(props: IQuestionElementProps<IElementQuestionYesNoV2>): ReactElement {
    const {element, device = DeviceType.DESKTOP} = props;

    const {t} = useTranslation();
    const getLabel = usePresentationLabels();

    return (
        <QuestionLayout element={element} device={device} showConfirmButton>
            <div
                className={`c-yesNoQuestion${device === DeviceType.MOBILE ? ' c-yesNoQuestion--mobile' : ''}`}
                style={{...getAnswerStyles(device, element)}}
            >
                {element.answers.map((answer, index) => (
                    <QuestionAnswer
                        key={`question-answer-${element.id}-${index}`}
                        answer={getLabel(answerLabelCode(answer.text)) || t(presEditYesNoAnswerKey(answer.text))}
                        answerType={mapAnswerType(answer.type)}
                        comment={answer.comment}
                        correctColor={element.correctColor}
                        incorrectColor={element.incorrectColor}
                        debatableColor={element.debatableColor}
                        styles={getAnswerStyles(device, element)}
                        onClick={() => undefined}
                    />
                ))}
            </div>
        </QuestionLayout>
    );
}

export default YesNoQuestionElementV2;
